import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { ClientNotificationHandlerService } from '@thehubz/client/core';

@Component({
  selector: 'sp-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
})
export class SnackBarComponent implements OnInit {
  progress = 0;
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackBarRef: MatSnackBarRef<SnackBarComponent>,
    private clientNotificationHandlerService: ClientNotificationHandlerService,
  ) { }

  ngOnInit(): void {
    this.data.duration.percent = 0;
    this.snackBarRef.afterOpened().subscribe({
      next: () => {
        this.progress = this.data.duration.percent || 0;
      },
      error: (err) => {
        this.clientNotificationHandlerService.errorNotification(err);
      },
    });
  }

  dismissWithAction() {
    this.snackBarRef.dismissWithAction();
  }
}
